module.exports = __webpack_public_path__ + "img/changePop.9d66ae18.png";